export class UrlUtils {
    static getUrlParams(customUrl?: string): Record<string, string> {
        let url = customUrl || window.location.href;

        url = decodeURIComponent(url);

        const questionMarkPosition = url.indexOf('?');

        if (questionMarkPosition < 0) {
            return {};
        }
        url = url.substr(questionMarkPosition + 1);

        return UrlUtils.parseQueryString(url);
    }

    static serializeUrlParams(params: Record<string, any>): string {
        if (Object.keys(params).length === 0) {
            return '';
        }

        let paramString = '?';
        for (const key of Object.keys(params)) {
            paramString += `${key}=${params[key]}&`;
        }

        return paramString.slice(0, -1);
    }

    static parseQueryString(queryString: string): Record<string, string> {
        const data = {};

        if (queryString === null) {
            return data;
        }

        const pairs = queryString.split('&');

        for (let i = 0; i < pairs.length; i++) {
            const pair = pairs[i];
            const separatorIndex = pair.indexOf('=');

            let escapedKey, escapedValue;

            if (separatorIndex === -1) {
                escapedKey = pair;
                escapedValue = null;
            } else {
                escapedKey = pair.substr(0, separatorIndex);
                escapedValue = pair.substr(separatorIndex + 1);
            }

            let key = decodeURIComponent(escapedKey);
            const value = decodeURIComponent(escapedValue);

            if (key.substr(0, 1) === '/') {
                key = key.substr(1);
            }

            data[key] = value;
        }

        return data;
    }
}
